import { Component, Input } from '@angular/core';
import i18next from 'i18next';

@Component({
  selector: 'app-delivered-vehicle',
  templateUrl: './delivered-vehicle.component.html',
  styleUrls: ['./delivered-vehicle.component.scss']
})
export class DeliveredVehicleComponent {
  @Input() deliveredVehicle?: any;
  @Input() vehicleRegistrationData?: any;
  @Input() appraisalValue?: number;

  emptyData = i18next.t('noData');

  getFormattedDescriptions(): string {
    if (
      this.deliveredVehicle?.optionals &&
      this.deliveredVehicle?.optionals.length > 0
    ) {
      return this.deliveredVehicle.optionals
        .map((optional: any) => optional.description)
        .join(' / ');
    }
    return '';
  }
}
